import React from 'react';
import ComponentBusy from '../ComponentBusy';
import PageHeader from '../PageHeader';
import './Page.scss';

export default function Page({ children, busy, title, padded, minWidth, headerItem })
{
    const pageStyles = {
        minWidth: minWidth || 0
    };

    return (
        <div className={'page-container ' + (padded ? 'padded' : '')} style={pageStyles}>
            {title ? <PageHeader title={title}>{headerItem}</PageHeader> : null}
            
            <div className='page'>
                {busy ? <ComponentBusy/> : null}
                {children}
            </div>
        </div>
    )
}